<template>
    <tbody>
    <tr v-for="row of all_transactions">
        <td>{{ row.id}}</td>
        <td>{{ row.transaction_date}}</td>
        <td>
            <span :style="'color:'+transactionColors[row.type - 1]">{{ transactionTypes[row.type - 1] }}</span>
        </td>
        <!-- <td>{{ getCurrency(row.client) }}{{ row.amount | formatNumber }}</td> -->

        <td style="width: 300px;">
        <span v-for="row1 of row.transaction_invoice">
          <span
                  v-html="'INV-00'+row1.invoice_id +'('+row1.proforma_invoice.car.model_type_en+') - due on '+ row1.proforma_invoice.due_date"
          ></span>
        </span>
        </td>

        <!-- <td style="width: 300px;" v-html="row.client"></td> -->
        <td class="has-text-danger">{{ getCurrency(row.client) }}{{ row.amount_used | formatNumber }}</td>
        <td class="has-text-success">{{ getCurrency(row.client) }}{{ row.unused_amount | formatNumber }}</td>
        <td>{{ getCurrency(row.client) }}{{ accumulativeDeposit(row) | formatNumber }}</td>
        <td v-if="isAdmin && $route.path != '/balance-statement/'">
            <router-link
                    tag="button"
                    :to="row.type == 1 ? '/balance-statement/edit/' + row.id : '/balance-statement/edit-refund/' + row.id"
                    class="button is-primary"
            >
                <span>Edit Transaction</span>
                <span class="icon is-small">
            <i class="fas fa-edit"></i>
          </span>
            </router-link>

            <a class="button is-danger" @click="transactionDeleteModal(row.id, row.type)">
                <span>Delete Transaction</span>
                <span class="icon is-small">
            <i class="fas fa-trash"></i>
          </span>
            </a>
        </td>
    </tr>
    </tbody>
</template>

<script>
    import apiBankingTransactions from "./../../api/apiBankingTransactions";
    export default {
        props: ["transactionTotals"],
        components: {},
        data() {
            return {
                transactionTypes: ["Money In", "Money Out", "Payment"],
                transactionColors: ["green", "red", "blue"],
                rows: [
                    [
                        "1",
                        "2020-06-06",
                        "Gabriel",
                        "REF#123",
                        '<span class="has-text-danger">MONEY OUT</span>',
                        "$1450",
                    ],
                    [
                        "1",
                        "2020-05-01",
                        "Juan",
                        "REF#123",
                        '<span class="has-text-success">MONEY IN</span>',
                        "$1270",
                    ],
                    [
                        "1",
                        "2020-04-04",
                        "Jorge",
                        "REF#123",
                        '<span class="has-text-primary">PAYMENT</span>',
                        "$370",
                    ],
                ],
            };
        },
        computed: {
            all_transactions() {
                return this.$store.getters.getAllTransactions;
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === "Admin") {
                    return true;
                }
            },
            currentRouteName() {
                return this.$route.name;
            },
            currentUserId() {
                return this.$store.getters.getCurrentUser.user.id;
            },
        },
        methods: {
            transactionDeleteModal(transactionId, type) {
                this.$store.commit("setTransactionDeleteModalStatus", true);
                this.$store.commit("setTransactionDeleteId", transactionId);
                this.$store.commit("setBTransactionType", type);
            },
            accumulativeDeposit(transaction){
                let deposit = Number(this.transactionTotals.deposit);
                let startSet = false;
                this.all_transactions.forEach((trans) => {
                    if(trans.id == transaction.id || startSet){
                        startSet = true;
                        if(trans.type == 1) {
                            deposit -= Number(trans.unused_amount);
                        }else{
                            deposit += Number(trans.amount);
                        }
                    }
                })
                if(transaction.type == 1){
                    deposit += Number(transaction.unused_amount);
                }else{
                    deposit -= Number(transaction.amount);
                }
                return deposit;
            },
            getCurrency(client) {
                return client.price_plan.deposit_rate == 1 ? "¥" : "$";
            },
        },
        created() {
            console.log(all_transactions());

            //this.$store.commit('setFilterTransactions', {client: '', search: '', dateFrom: '', dateTo: ''})
            this.$store.commit(
                "setTransactionCurrentPage",
                this.$route.query.page ? this.$route.query.page : 1
            );
            this.$store.commit(
                "setQueryClient",
                this.$route.params.id ? this.$route.params.id : this.currentUserId
            );
            this.$store.dispatch("getTransactionsAction");
        },
    };
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Balance-Statement/TransactionClientTableRow.vue